module.exports = __webpack_public_path__ + "img/motorcycle.fac1db91.png";